export default __webpack_public_path__ + "static/media/25083003.17e6361f.jpg";